import { pushAlert, ALERT_TYPES } from 'creatella-react-components/lib/reduxReducers/alerts';
import { getAllProducts, deleteProduct as deleteProductRequest, getProductById } from 'api/product';

const CLEAR_PRODUCTS_DATA = 'CLEAR_PRODUCTS_DATA';
const FETCH_PRODUCTS = 'FETCH_PRODUCTS';
const FETCH_PRODUCTS_SUCCESS = 'FETCH_PRODUCTS_SUCCESS';
const FETCH_PRODUCTS_FAILURE = 'FETCH_PRODUCTS_FAILURE';
const DELETE_PRODUCT = 'DELETE_PRODUCT';
const DELETE_PRODUCT_SUCCESS = 'DELETE_PRODUCT_SUCCESS';
const DELETE_PRODUCT_FAILURE = 'DELETE_PRODUCT_FAILURE';
const FETCH_SINGLE_PRODUCT = 'FETCH_SINGLE_PRODUCTS';
const FETCH_SINGLE_PRODUCT_SUCCESS = 'FETCH_SINGLE_PRODUCTS_SUCCESS';
const FETCH_SINGLE_PRODUCTS_FAILURE = 'FETCH_SINGLE_PRODUCTS_FAILURE';
const SET_QUERY_PRODUCTS = 'SET_QUERY_PRODUCTS';

const clearProductData = () => ({
    type: CLEAR_PRODUCTS_DATA
});

const fetchProducts = () => ({
    type: FETCH_PRODUCTS
});

const fetchProductsSuccess = (data) => ({
    type: FETCH_PRODUCTS_SUCCESS,
    data
});

const fetchProductsFailure = () => ({
    type: FETCH_PRODUCTS_FAILURE
});

const fetchSingleProduct = () => ({
    type: FETCH_SINGLE_PRODUCT
});

const fetchSingleProductSuccess = (data) => ({
    type: FETCH_SINGLE_PRODUCT_SUCCESS,
    data
});

const fetchSingleProductFailure = () => ({
    type: FETCH_SINGLE_PRODUCTS_FAILURE
});

const deleteProduct = (productId) => ({
    type: DELETE_PRODUCT,
    productId
});

const setQueryProduct = (query) => ({
    type: SET_QUERY_PRODUCTS,
    query
});

const deleteProductSuccess = (productId) => ({
    type: DELETE_PRODUCT_SUCCESS,
    productId
});

const deleteProductFailure = () => ({
    type: DELETE_PRODUCT_FAILURE
});

export function handleFetchProducts(query) {
    return async (dispatch) => {
        dispatch(fetchProducts());

        try {
            const { data } = await getAllProducts(query);

            dispatch(fetchProductsSuccess(data));
        } catch (e) {
            dispatch(fetchProductsFailure());
        }
    };
}

export function handleFetchSingleProduct(productId) {
    return async (dispatch) => {
        dispatch(fetchSingleProduct());

        try {
            const { data: { data } } = await getProductById(productId);

            dispatch(fetchSingleProductSuccess(data));
        } catch (e) {
            dispatch(fetchSingleProductFailure());
        }
    };
}

export function handleDeleteProduct(productId) {
    return async (dispatch) => {
        dispatch(deleteProduct());

        try {
            await deleteProductRequest(productId);
            dispatch(deleteProductSuccess(productId));
            dispatch(pushAlert({
                type: ALERT_TYPES.SUCCESS,
                message: 'Delete product success'
            }));
        } catch (e) {
            dispatch(deleteProductFailure());
            dispatch(pushAlert({
                type: ALERT_TYPES.ERROR,
                message: 'Fail delete product'
            }));
        }
    };
}

export function handleNextPage() {
    return async (dispatch) => {
        dispatch(fetchProducts());

        try {
            const { data } = await getAllProducts();

            dispatch(fetchProductsSuccess(data));
        } catch (e) {
            dispatch(fetchProductsFailure());
        }
    };
}

export function clearData() {
    return (dispatch) => {
        dispatch(clearProductData());
    };
}

// query -> { page, keyword }
export function handleQueryChange(query) {
    return async (dispatch) => {
        dispatch(setQueryProduct(query));
        dispatch(handleFetchProducts({
            search: query.keyword,
            page: query.page,
            published: query.published
        }));
    };
}

const INITIAL_STATE = {
    isLoading: true,
    products: [],
    selectedProductDetails: null,
    pages: {
        last_pages: 1,
        current_page: 1
    },
    count: {
        published: 0,
        unpublished: 0
    }
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case CLEAR_PRODUCTS_DATA:
            return {
                ...INITIAL_STATE
            };
        case FETCH_PRODUCTS:
            return {
                ...state
            };
        case FETCH_PRODUCTS_SUCCESS:

            return {
                ...state,
                isLoading: false,
                products: action.data.data,
                pages: action.data.meta,
                count: action.data.meta_count
            };
        case DELETE_PRODUCT_SUCCESS:
            return {
                ...state,
                products: state.products.filter(product => product.id !== action.productId)
            };
        case FETCH_SINGLE_PRODUCT:
            return {
                ...state
            };
        case FETCH_SINGLE_PRODUCT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                selectedProductDetails: action.data
            };
        case FETCH_SINGLE_PRODUCTS_FAILURE:
            return {
                ...state,
                selectedProductDetails: state.products.filter(product => product.id !== action.productId)
            };
        case SET_QUERY_PRODUCTS:
            return {
                ...state,
                pages: {
                    ...state.pages,
                    current_page: action.query.page
                }
            };
        default:
            return {
                ...state
            };
    }
};
